import { FC } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import { Sidebar, SideNav } from '@servicetitan/design-system';
import { SideNavLinkItem } from '@servicetitan/link-item';
import { useDependencies } from '@servicetitan/react-ioc';

import { AppNavItem, AppPageStructureType, getAppPageStructure } from '../../enums/routes';
import { FeaturesStore } from '../../../features/stores/features.store';

interface GroupProps {
    group: AppNavItem;
}

const Group: FC<GroupProps> = ({ group }) => {
    const location = useLocation();

    let isGroupActive = false;

    const groupBody = group.items.map(item => {
        const isActive = Boolean(
            matchPath(location.pathname, {
                path: item.path,
            }),
        );

        isGroupActive = isGroupActive || isActive;

        return (
            <SideNavLinkItem pathname={item.path} key={item.title}>
                {item.title}
            </SideNavLinkItem>
        );
    });

    return (
        <SideNav.Item
            key={group.key}
            collapsible={{ expanded: true }}
            icon={group.iconName}
            active={isGroupActive}
        >
            {group.title}
            <SideNav>{groupBody}</SideNav>
        </SideNav.Item>
    );
};

export function Navigation({ structure }: { structure: AppPageStructureType }) {
    return (
        <Sidebar localStorageKey="sidebar-application">
            <SideNav>
                {structure.map(group => (
                    <Group key={group.key} group={group} />
                ))}
            </SideNav>
        </Sidebar>
    );
}

export const AppNavigation = observer(() => {
    const [featuresStore] = useDependencies(FeaturesStore);

    return <Navigation structure={getAppPageStructure(featuresStore)} />;
});
